<template>
    <div>
        基础模块盒子
        <slot></slot>
    </div>
</template>

<script>

export default ({
    name: 'baseModule',
    props:{
        title: {
            type: String,
            default: "标题名称title"
        }
    },
    data() {
        return{
            
        }   
    },
})
</script>



// WEBPACK FOOTER //
// src/components/BaseModule.vue